<template>
  <div class="scoreReportBox">
    <!-- 头部 -->
    <div class="header">
      <div class="headerLeft">
        <img src="../../assets/icons/returnIcon.png" alt="" @click="goBack" />
        <span class="title">试卷分析报告</span>
      </div>
      <div class="headerRight" @click="showScoreInfo" v-if="false">
        评分说明
      </div>
    </div>

    <!-- 成绩卡片 -->
    <div class="scoreCard">
      <div class="cardBox">
        <div class="cardLeft">
          <div class="examTitle">{{ paperName }}</div>
          <div class="scoreInfo">
            <div class="infoItem">
              <span>答题数量：{{ finishCount }}/{{ topicList.length }}</span>
            </div>
            <div class="infoItem">
              <span>本场最佳：-</span>
            </div>
            <div class="infoItem">
              <span>答题用时：-</span>
            </div>
          </div>
        </div>
        <div class="cardRight">
          <div class="scoreCircle">
            <svg class="circle" width="80" height="80">
              <!-- 背景圆环 -->
              <circle
                cx="40"
                cy="40"
                r="36"
                fill="none"
                stroke="#e5e5e5"
                stroke-width="8"
              />
              <!-- 进度圆环 -->
              <circle
                cx="40"
                cy="40"
                r="36"
                fill="none"
                stroke="#1bbf8d"
                stroke-width="8"
                stroke-linecap="round"
                :stroke-dasharray="226.19"
                :stroke-dashoffset="circleDashOffset"
                transform="rotate(-90 40 40)"
              />
            </svg>
            <span class="score">{{ score }}</span>
          </div>
        </div>
      </div>
      <div class="rankBar">你的排名：-</div>
    </div>

    <!-- 排名条 -->

    <!-- 题目分析 -->
    <div class="analysisSection">
      <!-- A1/A2型题 -->
      <div class="questionType" v-if="a1a2Questions.length">
        <div class="typeTitle">【A1/A2型题】</div>
        <div class="questionGrid">
          <div
            v-for="(item, index) in a1a2Questions"
            :key="item.id"
            class="questionItem"
            :class="getQuestionClass(item)"
            @click="handleQuestionClick(item, index, 'a1a2')"
          >
            {{ index + 1 }}
          </div>
        </div>
      </div>

      <!-- A3/A4型题 -->
      <div class="questionType" v-if="a3a4Questions.length">
        <div class="typeTitle">【A3/A4型题】</div>
        <div class="questionGrid">
          <div
            v-for="(item, index) in a3a4Questions"
            :key="item.id"
            class="questionItem"
            :class="getQuestionClass(item)"
            @click="handleQuestionClick(item, index, 'a3a4')"
          >
            {{ index + a1a2Questions.length + 1 }}
          </div>
        </div>
      </div>

      <!-- B型题 -->
      <div class="questionType" v-if="bQuestions.length">
        <div class="typeTitle">【B型题】</div>
        <div class="questionGrid">
          <div
            v-for="(item, index) in bQuestions"
            :key="item.id"
            class="questionItem"
            :class="getQuestionClass(item)"
            @click="handleQuestionClick(item, index, 'b')"
          >
            {{ index + a1a2Questions.length + a3a4Questions.length + 1 }}
          </div>
        </div>
      </div>

      <!-- X型题 -->
      <div class="questionType" v-if="xQuestions.length">
        <div class="typeTitle">【X型题】</div>
        <div class="questionGrid">
          <div
            v-for="(item, index) in xQuestions"
            :key="item.id"
            class="questionItem"
            :class="getQuestionClass(item)"
            @click="handleQuestionClick(item, index, 'x')"
          >
            {{
              index +
              a1a2Questions.length +
              a3a4Questions.length +
              bQuestions.length +
              1
            }}
          </div>
        </div>
      </div>

      <!-- 判断题 -->
      <div class="questionType" v-if="judgeQuestions.length">
        <div class="typeTitle">【判断题】</div>
        <div class="questionGrid">
          <div
            v-for="(item, index) in judgeQuestions"
            :key="item.id"
            class="questionItem"
            :class="getQuestionClass(item)"
            @click="handleQuestionClick(item, index, 'judge')"
          >
            {{
              index +
              a1a2Questions.length +
              a3a4Questions.length +
              bQuestions.length +
              xQuestions.length +
              1
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  courseAnswerSheetDetail,
  planUserAnswerSheetDetail,
} from "@/api/courseTopic/index.js";
export default {
  data() {
    return {
      type: "",
      isStudy: "",
      isStudents: "",
      onlineCourseId: "",
      onlineCourseResourceId: "",
      paperId: "",
      planDetailId: "",
      queryType: "",
      paperStatus: "",
      topicList: [],
      paperName: "",
      finishCount: "",
      score: "",
      userId: "",
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.isStudy = this.$route.query.isStudy;
    this.isStudents = this.$route.query.isStudents;
    this.onlineCourseId = this.$route.query.onlineCourseId;
    this.onlineCourseResourceId = this.$route.query.onlineCourseResourceId;
    this.paperId = this.$route.query.paperId;
    this.planDetailId = this.$route.query.planDetailId;
    this.queryType = this.$route.query.queryType;
    this.paperStatus = this.$route.query.paperStatus;
    this.userId = this.$route.query.userId;
    this.getAnswerSheet();
  },
  computed: {
    a1a2Questions() {
      return this.topicList.filter(
        (q) => q.questionType === 0 || q.questionType === 1
      );
    },
    a3a4Questions() {
      return this.topicList.filter(
        (q) => q.questionType === 2 || q.questionType === 3
      );
    },
    bQuestions() {
      return this.topicList.filter((q) => q.questionType === 4);
    },
    xQuestions() {
      return this.topicList.filter((q) => q.questionType === 5);
    },
    judgeQuestions() {
      return this.topicList.filter((q) => q.questionType === 6);
    },
    circleDashOffset() {
      const total = 2 * Math.PI * 36; // 226.19
      const percent = Math.max(0, Math.min(Number(this.score), 100)) / 100;
      return total * (1 - percent);
    },
  },
  methods: {
    async getAnswerSheet() {
      let data;
      if (this.type == 1) {
        const setList = {
          onlineCourseId: this.onlineCourseId,
          onlineCourseResourceId: this.onlineCourseResourceId,
          paperId: this.paperId,
        };
        ({ data } = await courseAnswerSheetDetail(setList));
      } else if (this.type == 2) {
        const setList = {
          planDetailId: this.planDetailId,
          paperId: this.paperId,
          userId: this.userId,
        };
        ({ data } = await planUserAnswerSheetDetail(setList));
      }
      this.paperName = data.paperName;
      this.finishCount = data.finishCount;
      this.score = data.score;
      this.topicList = data.questionList || [];
    },
    goBack() {
      this.$router.go(-1);
    },
    showScoreInfo() {
      // 显示评分说明
      console.log("显示评分说明");
    },
    getQuestionClass(item) {
      if (item.isRight === 1) return "correct";
      if (item.isRight === 0) return "wrong";
      return "unanswered";
    },
    handleQuestionClick() {
      if (this.type == 1) {
        this.$router.push({
          path: "/courseTopic",
          query: {
            type: 1,
            isStudy: this.isStudy,
            isStudents: this.isStudents,
            onlineCourseId: this.onlineCourseId,
            onlineCourseResourceId: this.onlineCourseResourceId,
            paperId: this.paperId,
          },
        });
      } else {
        this.$router.push({
          path: "/courseTopic",
          query: {
            type: 2,
            queryType: this.queryType,
            paperStatus: this.paperStatus,
            paperId: this.paperId,
            planDetailId: this.planDetailId,
            userId: this.userId,
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.scoreReportBox {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  overflow: hidden;

  .header {
    display: flex;
    justify-content: space-between;
    // align-items: center;
    width: 100%;
    height: 228px;
    padding: 44px 16px 0px 16px;
    color: white;
    background-image: url("../../assets/images/scoreReport.png");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;

    .headerLeft {
      display: flex;
      //   align-items: center;

      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }

      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 17px;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
        font-style: normal;
      }
    }

    .headerRight {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
      font-style: normal;
    }
  }

  .scoreCard {
    position: absolute;
    top: 105px;
    left: 16px;
    right: 16px;
    height: 171px;
    border-radius: 10px;
    background-color: #ffffff;
    .cardBox {
      display: flex;
      justify-content: space-between;
      padding: 20px 16px;
      height: 136px;
      .cardLeft {
        .examTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #121212;
          line-height: 22px;
          font-style: normal;
          margin-bottom: 8px;
        }

        .scoreInfo {
          .infoItem {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            line-height: 17px;
            font-style: normal;
            margin-bottom: 8px;
          }
        }
      }
      .cardRight {
        display: flex;
        align-items: center;
        .scoreCircle {
          width: 80px;
          height: 80px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          .circle {
            width: 80px;
            height: 80px;
          }

          .score {
            position: absolute;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 20px;
            color: #1bbf8d;
            z-index: 1;
          }
        }
      }
    }
    .rankBar {
      padding-left: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      font-style: normal;
      width: 100%;
      height: 34px;
      line-height: 34px;
      background-image: url("../../assets/images/rankBar.png");
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
  }

  .analysisSection {
    position: absolute;
    top: 276px;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 16px 16px;
    overflow-y: auto;

    .questionType {
      margin-bottom: 32px;

      .typeTitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #333333;
        margin-bottom: 16px;
      }

      .questionGrid {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 12px;

        .questionItem {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          cursor: pointer;

          &.correct {
            background: #1bbf8d;
            color: white;
          }

          &.wrong {
            background: #ff4757;
            color: white;
          }

          &.unanswered {
            background: #f5f5f5;
            color: #999999;
            border: 1px solid #e5e5e5;
          }
        }
      }
    }
  }
}
</style>